import { Box, Button, Container, TextField } from '@mui/material'
import { useCallback, useState } from 'react'
const Logo = require('assets/images/new_logo.png')

export function Login(): JSX.Element {
  const [showCredentials, setShowCredentials] = useState(false)
  const [loginValue, setLoginValue] = useState('')
  const [password, setPassword] = useState('')

  const handleCredentialsClick = useCallback(() => {
    setShowCredentials(true)
  }, [])

  return (
    <Container>
      <Box
        minHeight="100vh"
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
      >
        <Box marginBottom={1.5}>
          <img src={Logo} alt="Logo" />
        </Box>
        {!showCredentials && <span>ASAN login</span>}
        <Box marginTop={1}>
          {!showCredentials && (
            <Button
              onClick={handleCredentialsClick}
              variant="contained"
              style={{ color: '#fff', backgroundColor: 'rgb(3, 34, 76)' }}
            >
              Log in with credentials
            </Button>
          )}
          {showCredentials && (
            <Box marginTop={1} display="flex" flexDirection="column">
              <TextField
                sx={{ marginBottom: 1.5, minWidth: 320 }}
                size="small"
                value={loginValue}
                onChange={(e) => setLoginValue(e.target.value)}
                label="Login"
              />
              <TextField
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                type="password"
                label="Password"
                size="small"
              />
              <Button
                variant="contained"
                style={{ color: '#fff', backgroundColor: 'rgb(3, 34, 76)' }}
                sx={{ marginTop: 1.5 }}
              >
                Login
              </Button>
              <Button
                onClick={() => setShowCredentials(false)}
                sx={{ marginTop: 1.5 }}
              >
                Back
              </Button>
            </Box>
          )}
        </Box>
      </Box>
    </Container>
  )
}
